var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "error-wrapper" } }, [
    _vm._m(0),
    _c("div", { attrs: { id: "error-title" } }, [
      _vm._v(_vm._s(_vm.errorTitle)),
    ]),
    _c("div", { attrs: { id: "error-text" } }, [_vm._v(_vm._s(_vm.errorText))]),
    _c("div", { attrs: { id: "error-code" } }, [
      _vm._v("Error code " + _vm._s(_vm.errorCodeWithDefault)),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { attrs: { id: "error-img-wrapper" } }, [
      _c("div", { staticClass: "sprite error-cc", attrs: { id: "error-img" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }